import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=71356da3&scoped=true&lang=pug&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=71356da3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71356da3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71356da3')) {
      api.createRecord('71356da3', component.options)
    } else {
      api.reload('71356da3', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=71356da3&scoped=true&lang=pug&", function () {
      api.rerender('71356da3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Icon.vue"
export default component.exports